import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchTypologies, fetchedTypologies, fetchConflictTypes, fetchedConflictTypes } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type FetchActionPayload = ReturnType<typeof fetchTypologies>;

export function* getTypologiesSaga({ meta: { callback } }: FetchActionPayload) {
  const { getTypologies } = getAPI();
  const response: YieldOf<typeof getTypologies> = yield call(getTypologies);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedTypologies(data || []));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedTypologies(undefined, error));
  }

  if (callback) callback();
}

export function* getConflictTypesSaga({ meta: { callback } }: FetchActionPayload) {
  const { getConflictTypes } = getAPI();
  const response: YieldOf<typeof getConflictTypes> = yield call(getConflictTypes);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedConflictTypes(data || []));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedConflictTypes(undefined, error));
  }

  if (callback) callback();
}

export default function* typologiesSaga() {
  yield takeLatest(fetchTypologies.type, getTypologiesSaga);
  yield takeLatest(fetchConflictTypes.type, getConflictTypesSaga);
}
